var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddcontact = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128pt",
    height: "128pt",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00abe6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m50.305 18.559c-11.391 0-20.609 9.2148-20.609 20.609 0 11.391 9.2148 20.609 20.609 20.609 11.391 0 20.609-9.2148 20.609-20.609-0.003906-11.266-9.2188-20.609-20.609-20.609z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.801 104.96c-0.25391 2.3047 1.6641 4.4805 3.9688 4.4805h66.945c2.4297 0 4.2266-2.0508 3.9688-4.4805-1.9258-20.734-17.926-36.988-37.379-36.988-19.453 0-35.453 16.254-37.504 36.988z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.98 57.469h-8.4492v-8.4492c0-2.3047-1.9219-4.2266-4.2266-4.2266-2.3047 0-4.2266 1.9219-4.2266 4.2266v8.4492h-8.4492c-2.3047 0-4.2266 1.9219-4.2266 4.2266 0 2.3047 1.9219 4.2266 4.2266 4.2266h8.4492v8.4492c0 2.3047 1.9219 4.2266 4.2266 4.2266 2.3047 0 4.2266-1.9219 4.2266-4.2266v-8.4492h8.4492c2.3047 0 4.2266-1.9219 4.2266-4.2266 0-2.3047-1.9219-4.2266-4.2266-4.2266z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddcontact);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/addcontact.b611be9247467367364c3ea9d8cec0b6.svg";